module.exports = __webpack_public_path__ + "img/090.d41caf97.jpg";